import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSlider from "./components/HeroSlider";
import StatsSection from "./components/StatsSection";
import CompanySection from "./components/CompanySection";
import SolutionsGrid from "./components/SolutionsGrid";
import WhyWorkWithUsSection from "./components/WhyWorkWithUsSection";
import ClientsWeServeSection from "./components/ClientsWeServeSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSlider />
      <StatsSection />
      <CompanySection />
      <SolutionsGrid />
      <WhyWorkWithUsSection />
      <ClientsWeServeSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}